import { render, staticRenderFns } from "./Bunker.vue?vue&type=template&id=72ce25de&scoped=true&"
import script from "./Bunker.vue?vue&type=script&lang=js&"
export * from "./Bunker.vue?vue&type=script&lang=js&"
import style0 from "./Bunker.vue?vue&type=style&index=0&id=72ce25de&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ce25de",
  null
  
)

export default component.exports